export const saveJoinAllow = (roomId: string, bid: string) => {
  window.sessionStorage.setItem(`join-allow-${roomId}`, bid);
};

export const isSavedJoinAllow = (roomId: string, bid: string) => {
  const savedBid = window.sessionStorage.getItem(`join-allow-${roomId}`);
  return savedBid === bid;
};

export const removeJoinAllow = (roomId: string) => {
  window.sessionStorage.removeItem(`join-allow-${roomId}`);
};
